export const linkProps = [
  { name: 'Collection', value: 'collections' },
  { name: 'Source', value: 'sources' },
  { name: 'Entry', value: 'entries' },
];
